import { render, staticRenderFns } from "./VectorDisplay.vue?vue&type=template&id=af875532&scoped=true&"
import script from "./VectorDisplay.vue?vue&type=script&lang=js&"
export * from "./VectorDisplay.vue?vue&type=script&lang=js&"
import style0 from "./VectorDisplay.vue?vue&type=style&index=0&id=af875532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af875532",
  null
  
)

export default component.exports